<template>
	<page :title="'Invoice #' + invoice.id" :breadcrumbs="breadcrumbs">
		<template #actions>
			<a :href="route('invoices.download', invoice)"
				target="_blank"
				class="v-btn v-btn--has-bg theme--light elevation-0 v-size--default primary v-size--small">
				<v-icon left dark>mdi-download</v-icon>
				<span class="v-btn__content">Download PDF</span>
			</a>

			<send :invoice="invoice" />

			<create-payment v-if="invoice.total_due > 0" />

			<v-menu
				v-model="statusMenu"
				offset-y
				:nudge-width="200"
				:close-on-content-click="false">
				<template #activator="{ on, attrs }">
					<fieldset class="ml-5">
						<legend>Invoice Status</legend>
						<v-btn
							:color="invoice.status.color"
							dark
							large
							min-width="200"
							elevation="0"
							v-bind="attrs"
							v-on="on">
							{{ invoice.status.name }}
						</v-btn>
					</fieldset>
				</template>
				<v-card v-if="length(statuses)">
					<v-card-text>
						<v-autocomplete
							v-model="statusId"
							:items="statuses"
							placeholder="Change Status"
							filled
							outlined
							clearable
							hide-details>
							<template #selection="data">
								<v-icon left :color="data.item.color">mdi-circle</v-icon>
								<span>{{ data.item.name }}</span>
							</template>
							<template #item="data">
								<v-icon left :color="data.item.color">mdi-circle</v-icon>
								<span>{{ data.item.name }}</span>
							</template>
						</v-autocomplete>
						<v-btn color="primary"
							class="mt-3"
							@click="updateStatus">
							Change Status
						</v-btn>
					</v-card-text>
				</v-card>
			</v-menu>
		</template>

		<v-card>
			<v-tabs v-model="tab" bg-color="primary" align-tabs="center">
				<v-tab>Invoice</v-tab>
				<v-tab><div class="mr-2">Payments</div> <v-chip small>{{ length(invoice.payments) }}</v-chip></v-tab>
				<v-tab>Audit Log</v-tab>
				<Link color="secondary"
					:href="route('projects.show', invoice.project)"
					class="v-btn v-btn--plain theme--light v-size--default secondary--text ml-auto mt-1">
					<v-icon left small>mdi-arrow-left</v-icon>
					Back to Project
				</Link>
			</v-tabs>

			<v-divider />

			<v-window v-model="tab">
				<v-window-item>
					<invoice-template :invoice="invoice" />
				</v-window-item>

				<v-window-item>
					<payments-table :payments="payments" />
				</v-window-item>

				<v-window-item>
					<invoice-log :log="log" />
				</v-window-item>
			</v-window>
		</v-card>
	</page>
</template>
<script>
import api from '@/api'
import Backend from '@/Layouts/Backend'
import Page from '@/Pages/Backend/Components/Page'
import InvoiceTemplate from './Invoice'
import Send from '@/Pages/Backend/Invoices/Send.vue'
import InvoiceLog from './Log'
import PaymentsTable from '@/Pages/Backend/Payments/Table'
import CreatePayment from '@/Pages/Backend/Payments/Create'

export default {
	components: { Page, InvoiceTemplate, InvoiceLog, Send, PaymentsTable, CreatePayment },
	layout: Backend,
	props: {
		invoice: {
			type: Object,
			default: () => {},
			required: true
		},
		payments: {
			type: Object,
			default: () => {}
		},
		log: {
			type: Array,
			default: () => [],
			required: false
		},
		settings: {
			type: Object,
			default: () => {},
			required: true
		},
		filename: {
			type: String,
			default: 'Invoice.pdf'
		}
	},
	data () {
		return {
			tab: 0,
			breadcrumbs: [
				{ route: 'dashboard', label: 'Dashboard' },
				{ route: 'clients.show', params: { client: this.invoice.project.client }, label: this.invoice.project.client.name },
				{ route: 'projects.index', label: 'Projects' },
				{ route: 'projects.show', label: this.invoice.project.name, params: { id: this.invoice.project.id }, id: this.invoice.project.id },
				{ route: 'invoices.index', label: 'Invoices' },
				{ label: this.invoice.id }
			],
			statusMenu: false,
			statusId: this.invoice.status.value,
			statuses: []
		}
	},
	mounted () {
		this.getInvoiceStatuses()
	},
	methods: {
		getInvoiceStatuses () {
			const method = 'GET'
			const data = {}

			const url = this.route('invoices.api.statuses')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.statuses = response.data
			})
		},

		updateStatus () {
			const data = { status: this.statusId }
			this.$inertia.put(this.route('invoices.update.status', this.invoice), data, {
				only: ['invoice', 'flash'],
				onFinish: () => {
					this.statusMenu = false
					this.statusId = this.invoice.status.value
				},
				preserveState: true,
				preserveScroll: true
			})
		}
	}
}
</script>
